var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('b-button',_vm._b({staticClass:"icon-button",on:{"click":function($event){return _vm.$emit('click', $event)}}},'b-button',_vm.$attrs,false),[_c('i',{class:['fe', ("fe-" + _vm.icon)]})])}
var staticRenderFns = []

export { render, staticRenderFns }